import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';

export const PriorityWeldIconStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'center' },
})`
  ${({ theme }) => css`
    border-radius: ${theme.radii[100]};
    height: calc(${theme.spacings[500]} + ${theme.spacings[100]});
    width: calc(${theme.spacings[500]} + ${theme.spacings[100]});
    background-color: ${theme.colors.red[500]};
  `}
`;
